import { z } from "zod";

import { LoginSchema, MagicPasswordLoginSchema } from "./auth.schema";

export enum Roles {
  SUPER_ADMIN = "SUPERADMIN",
  ADMIN = "ADMIN",
}

export type LoginFormData = z.infer<typeof LoginSchema>;
export type MagicPasswordLoginFormData = z.infer<
  typeof MagicPasswordLoginSchema
>;

type VerifiedEmailLoginFormData = {
  type: "email";
  email: string;
  otp?: number;
  doAgreed?: boolean;
};

type VerifiedPhoneLoginFormData = {
  type: "phone";
  phone: string;
  otp?: number;
  doAgreed?: boolean;
};

export type VerifyLoginFormData =
  | VerifiedEmailLoginFormData
  | VerifiedPhoneLoginFormData;

export interface GetAuthLoginArgs {
  token?: string;
  type?: string;
}

export interface DoAuthLoginArgs {
  data: LoginFormData | VerifyLoginFormData;
  loginMethod: string;
}

export interface GetAuthInfoArgs {
  workspaceId: string;
  token?: string | null;
}

export interface MagicPasswordLoginArgs {
  data: MagicPasswordLoginFormData;
}

export interface CreateWorkspaceSwitchCodeArgs {
  targetWorkspace: string;
}

export interface ExchangeWorkspaceSwitchCodeArgs {
  code: string;
}
